import { BackdropGlyph, Display, Eyebrow, Heading, Mono, Section } from "@ffn/components"
import { createFileRoute } from "@tanstack/react-router"
import { ESSAYS, SIDE_QUESTS } from "../content/field-notes.js"
import { EssayList, SideQuestList } from "../features/NoteList.js"
import { notesHead } from "../seo/index.js"
import "../notes.css"

export const Route = createFileRoute("/notes/")({
  head: () => notesHead(ESSAYS, SIDE_QUESTS),
  component: NotesPage
})

/**
 * The hub: one H1, a standfirst, then the two groups under their own H2s. The
 * essays are the long-form entries, the side quests the short ones, and each
 * group's header carries a different brand watermark: `frontier` (the house mark)
 * behind the Field Notes, `sidequest` (a branch off the main line) behind the
 * Side Quests, bleeding from opposite corners.
 */
function NotesPage() {
  return (
    <>
      <Section className="SiteSection">
        <Eyebrow>Writing</Eyebrow>
        <Display>Frontier Field Notes</Display>
        <p className="SiteNotesStandfirst">
          Writing from the autonomous work horizon: how long an agent can work on its own, what it
          needs to get there, and how to tell when it's slipping. Field Notes are the long-form
          essays, numbered as a series. Side Quests are the short detours that didn't need one.
        </p>
      </Section>
      <Section className="SiteSection SiteNotesGroup" aria-labelledby="field-notes">
        <header className="SiteNotesHead">
          <BackdropGlyph corner="tr" kind="frontier" />
          <Eyebrow>Long form</Eyebrow>
          <Heading id="field-notes" level={2}>
            Field Notes
          </Heading>
          <span className="SiteNotesCount">
            <Mono>{`${ESSAYS.length} essays`}</Mono>
          </span>
        </header>
        <EssayList notes={ESSAYS} />
      </Section>
      <Section className="SiteSection SiteNotesGroup" aria-labelledby="side-quests">
        <header className="SiteNotesHead">
          <BackdropGlyph corner="tr" kind="sidequest" />
          <Eyebrow>Short</Eyebrow>
          <Heading id="side-quests" level={2}>
            Side Quests
          </Heading>
          <span className="SiteNotesCount">
            <Mono>{`${SIDE_QUESTS.length} detours`}</Mono>
          </span>
        </header>
        <SideQuestList notes={SIDE_QUESTS} />
      </Section>
    </>
  )
}
